/**
 * review-1008-Frontend-7252 (T22.232 follow-up): which pages host the
 * Create-a-Wheel wizard?
 *
 * The wizard (CreateWheelPopup) is mounted per page: Discover, Following,
 * Gallery and Capture. FE#7252 made the shared header render the Create Wheel
 * button on EVERY phone page, including /settings, the View Wheel page,
 * Notifications, Help, Chat and the Media Library, none of which mount the
 * wizard. A tap there set createWheelPopup.isOpen and nothing rendered it, so
 * the button looked dead (MEASURED web-stg main.5a0a39dd @390: create-wheel
 * check 200, 0 wizard dialogs). The stale isOpen then popped the wizard open
 * unasked on the next page that does host it.
 *
 * Every page-level CreateWheelPopup registers here; GalleryHeader mounts its
 * own fallback wizard only while the wizard is open and nobody is registered.
 */
import { useLayoutEffect, useSyncExternalStore } from "react";

let hostCount = 0;
const listeners = new Set();

const emit = () => listeners.forEach((l) => l());

export const getCreateWheelHostCount = () => hostCount;

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** Register the calling component as a page-level wizard host. */
export function useRegisterCreateWheelHost(enabled = true) {
  useLayoutEffect(() => {
    if (!enabled) return undefined;
    hostCount += 1;
    emit();
    return () => {
      hostCount -= 1;
      emit();
    };
  }, [enabled]);
}

/** True while at least one page-level wizard host is mounted. */
export function useHasCreateWheelHost() {
  return useSyncExternalStore(
    subscribe,
    () => hostCount > 0,
    () => false
  );
}
